import type { FaireReviewEntity } from "../../entity_types/review";

export const defaultReview: FaireReviewEntity = {
  token: "default",
  type: "review",
  reviewDate: "2026-03-24",
  reviewerName: "Default Reviewer",
  reviewText: "Default review",
  stars: 5,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
